/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForCloudStack extends models.ServiceAccountCredentialsBase {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForCloudStack");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForCloudStack.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForCloudStack>): ServiceAccountCredentialsForCloudStack {
        let obj = Object.assign(new ServiceAccountCredentialsForCloudStack(), model);
        ServiceAccountCredentialsForCloudStack.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForCloudStack>): ServiceAccountCredentialsForCloudStack {
        if (!model) return null;
        return ServiceAccountCredentialsForCloudStack.newInstance(<ServiceAccountCredentialsForCloudStack> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForCloudStack) {
        if (!obj) return;

        models.ServiceAccountCredentialsForCloudStack.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForCloudStack): boolean {
        if (models.ServiceAccountCredentialsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForCloudStack.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * API Key. This is a required field.
     */
    api_key: string;

    /**
     * Secret Key. This is a required field.
     */
    secret_key: string;

    /**
     * Auth URL. This is a required field.
     */
    auth_url: string;

}
